import { PageTransferBatchesOverview } from './Overview';
import { PageTransferBatchesView } from './View';

export const TRANSFER_BATCHES = {
  TransferBatchesView: PageTransferBatchesView,
  TransferBatchesOverview: PageTransferBatchesOverview,
} as const;
